import React, {Component} from 'react';
import Loading from '../loading';
import joinReact from '../join_react';
import GroupsInformation from '../groups_information';
import GeolocationInformation from '../geolocation_information';
import ReferencesSummary from '../references_summary';

import Form from '../form';
import RecordNotesWidget from '../record_notes_widget';


import request from '../../request';

export default class SearchResult extends Component {
  constructor(props) {
    super(props);

    let in_collections = findCollections(props);
    this.state = {in_collections, show_others: false};
  }

  static getDerivedStateFromProps(props, state) {
    state.in_collections = findCollections(props);
    return state;
  }

  addToCollection(collection) {
    let {trial, patient, addTrialToCollection} = this.props;
    let url = "/admin/patients/" + patient.id + "/collections/" + collection.id + "/trials"
    request('POST', url, {trial_id: trial.id}).then(({success, collection_trial}) => {
      let {in_collections} = this.state;
      in_collections.push(collection);
      this.setState({in_collections});
      addTrialToCollection(collection_trial)
    });
  }

  newCollection() {
    this.setState({show_new_collection_form: true});
  }

  closeNewCollection() {
    this.setState({show_new_collection_form: false});
  }

  onCollectionAdded(collection) {
    let {collections, onCollectionsChange} = this.props;
    collections.push(collection);
    onCollectionsChange(collections);
    this.addToCollection(collection);
  }

  toogleSelected() {
    let {trial, selectCallback} = this.props;
    selectCallback && selectCallback(trial);
  }

  toggleOtherPopulationsVisibility(e) {
    let show_others = !this.state.show_others;
    this.setState({show_others});
  }

  toggleReferencesVisibility() {
    let show_references = !this.state.show_references;
    this.setState({show_references})
  }

  renderNewCollectionModal() {
    let {patient} = this.props;
    let {show_new_collection_form} = this.state;
    if (!show_new_collection_form) return null;
    return <CollectionModal patient={patient} onClose={e => this.closeNewCollection()} onSubmit={c => this.onCollectionAdded(c)} />
  }

  renderNCT(trial) {
    let identifier, status, overall_status;

    // Set the link data
    if (trial.isTrial) {
      identifier = <a href={trial.study_url} target="_blank">{trial.identifier}</a>
    } else {
      identifier = trial.identifier;
    }

    if (trial.status_humanized) {
      status = "[" + trial.status_humanized + "]"
    }

    if (trial.isTrial) {
      let label = trial.overall_status_humanized || "No Status"
      overall_status = "(" + label + ")"
    }

    return(
      <span>
        {identifier} {overall_status} {status}
      </span>
    )
  }

  renderStartDate(trial) {
    let date = trial.start_date;
    let type = trial.start_date_type;

    return (
      <span>Start: {date} ({type})</span>
    );

  }

  renderOtherPopulations(populations_data) {
    if (!this.state.show_others) return null;

    let others = [];
    for (let i=1; i < populations_data.length; i++) {
      let population = populations_data[i];
      let link = linkToPopulation(population);
      let notes_icon;
      if (population.has_notes) {
        let notes_link = `/admin/trials/${population.trial_id}/populations/${population.id}#notes`;
        notes_icon = <a href={notes_link} target="_blank"><span className="glyphicon glyphicon-comment" /></a>
      }
      others.push(
        <li key={population.id}>
          <a href={link} target="_blank">{population.name}</a> {notes_icon}
        </li>
      );
    }

    return (
      <div className="other_populations">
        <ul>
          {others}
      </ul>
      </div>
    );
  }

  renderPopulationsInfo(populations) {
    if (populations.length < 2 || !this.props.admin_mode) return null;

    let link_copy = this.state.show_others ? "Close" : "Show"

    return (
      <div className="populations_info">
        <div className="copy">
          {populations.length -1} other populations for this therapy
          <button className="show_populations_button pull-right" onClick={e => this.toggleOtherPopulationsVisibility(e)}>{link_copy}</button>
          <div className="clearfix"></div>
        </div>
        {this.renderOtherPopulations(populations)}
      </div>
    )
  }

  renderIcons(trial) {
    let combination = trial.included_combination;
    let random = trial.arm_randomized;
    let placebo = trial.includes_placebo;

    let ref_icon;
    if (trial.scorabe_or_notable_references_count > 0) {
      ref_icon = <button className="btn btn-link" onClick={e => this.toggleReferencesVisibility()}><i className="fa fa-book green" title="References" /></button>
    } else if (trial.trial_references_changelog.length > 0) {
      ref_icon = <button className="btn btn-link" onClick={e => this.toggleReferencesVisibility()}><i className="fa fa-book red" title="References" /></button>
    } else {
      ref_icon = <i className="fa fa-book no-reference" title="References" />
    }

    return (
      <span className="trial_icons">
        {ref_icon}
        <i className="fa fa-plus-circle" data-enabled={combination} title="Combination" />
        <i className="fa fa-random" data-enabled={random} title="Randomization" />
        <i className="fa fa-exclamation-circle" data-enabled={placebo} title="Placebo" />
      </span>
    )
  }

  renderGenes(population) {
    if (!population.genes_markers_information_present) return null;
    return (
      <div className="genes_markers">
        <h4>Genes &amp; Diagnostics:</h4>
        {population.genes_markers_information.map(i => {
          return (
            <ul key={i.section}>
              {i.content.map(({title, body}, index) => {
                return(
                  <li key={index}>
                    <strong>{title}:</strong> {body}
                    </li>
                )
              })}
            </ul>
          )})
        }
      </div>
    )
  }

  renderSelectedIcon() {
    let {selected} = this.props;
    let icon = selected ? 'glyphicon-star' : 'glyphicon-star-empty';
    let btnStyle = selected ? 'btn btn-success pull-right' : 'btn btn-default pull-right';
    let className = 'glyphicon ' + icon;
    return (
      <button className={btnStyle} onClick={e => this.toogleSelected()}><i className={className} /></button>
    )
  }


  renderPopulationName(population) {
    if (this.props.admin_mode) {
      let link = linkToPopulation(population);
      return <a href={link} target="_blank">{population.name}</a>;
    } else {
      return population.name;
    }
  }


  renderCollectionsButton() {
    let {collections, patient} = this.props;
    if (!patient) return null;

    let {in_collections} = this.state;
    return (
      <div className="dropdown" style={{display: 'inline-block'}}>
        <button className="btn btn-default dropdown-toggle add-collection-btn" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
          Add to collection <span className="caret"></span>
        </button>

        <ul className="dropdown-menu">
          {collections.map(collection => {
            if (in_collections.findIndex(c => collection.id === c.id) === -1) {
              return <li key={collection.id}><button className="btn btn-link" onClick={e => this.addToCollection(collection)}>{collection.name}</button></li>
            } else {
              return <li key={collection.id}><span className="in-collection-span">{collection.name}</span></li>
            }
          })}

          <li role="separator" className="divider"></li>
          <li><button className="btn btn-link" onClick={e => this.newCollection()}>Create New Collection</button></li>
        </ul>
      </div>
    )
  }

  renderRecentAndConcurrentConfig(population) {
    if (!population['recent_configured?'] && !population['concurrent_configured?']) return null;

    let link_to_recent = `/admin/trials/${population.trial_id}/populations/${population.id}#recent`;
    let link_to_concurrent = `/admin/trials/${population.trial_id}/populations/${population.id}#concurrent`;

    let recent_link = <a href={link_to_recent} target="_blank">Recent</a>;
    let concurrent_link = <a href={link_to_concurrent} target="_blank">Concurrent</a>;
    let text;

    if (population['recent_configured?'] && population['concurrent_configured?']) {
      text = <span>{recent_link} and {concurrent_link}</span>
    } else if (population['recent_configured?']) {
      text = recent_link
    } else if (population['concurrent_configured?']) {
      text = concurrent_link
    }

    return (
      <div className="result_therapy_text">
        <p>This trial has {text} therapy requirements.</p>
      </div>
    )
  }



  renderButtons() {
    let {admin_mode, trial, population_data, link, trial_show} = this.props;
    if (!admin_mode) return null;


    return (
      <div className="search-action-group">
        <div className="btn-group">
          <a className="btn btn-default" href={linkToPopulation(population_data[0])} target="_blank">Population</a>
          <a className="btn btn-default" href={link} target="_blank">Trial</a>
          <a className="btn btn-default" href={trial_show} target="_blank">View</a>
          <a className="btn btn-default" href={trial_show + "/references"} target="_blank">References</a>
        </div>
        <div className="search-action-sub-group">
          {this.renderCollectionsButton()}
          <RecordNotesWidget record_type="Trial" record_id={trial.id} buttonClassName="btn btn-default" />
        </div>
      </div>
    )
  }


  renderPatientInformation() {
    let {in_collections} = this.state;
    if (in_collections.length === 0) return null;
    let {patient} = this.props;
    let links = in_collections.map(collection => {
      let url = "/admin/patients/" + patient.id + "/collections/" + collection.id;
      return <a key={collection.id} href={url}>{collection.name}</a>
    })

    return (
      <p className="current-collections">
        In these collection(s): {joinReact(links, ', ')}
      </p>
    )
  }

  renderLastLocationVerifiedAt() {
    let {trial} = this.props;
    if (!trial.last_location_verified_at) return null;
    let date = moment(trial.last_location_verified_at).format('LL');
    return <span className="label label-primary">Last trial location verificaion: {date}</span>;
  }

  render() {
    let {score, rating_score, trial, match_label, population_data, patient, admin_mode, index, new_result, extra_locations, geolocation, reference_population_ids} = this.props;

    let population = population_data[0];
    let notes_icon;
    if (population.has_notes) {
      let notes_link = `/admin/trials/${population.trial_id}/populations/${population.id}#notes`;
      notes_icon = <a href={notes_link} target="_blank"><span className="glyphicon glyphicon-comment" /></a>
    }

    let container_class = "search_result_container";
    if (new_result) container_class += " new_result";

    return(
      <div className={container_class}>
        <div className="search_result">
          <h1 className="search_result_index">{index}</h1>
          <div className="row">
            <div className="col-md-12">
              {this.renderSelectedIcon()}
              <h4>{match_label}: {this.renderPopulationName(population)} {notes_icon}</h4>
            </div>
          </div>

          <p className="result_name">
            {trial.name}
          </p>
          <p className="search_trial_info">{this.renderIcons(trial)} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{this.renderNCT(trial)} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; {this.renderStartDate(trial)}</p>
          <ReferencesSummary trial={trial} reference_population_ids={reference_population_ids} checkMatching/>
          {this.renderGenes(population)}

          <div className="search_results_group_details">
            <h4>Interventions:</h4>
            <GroupsInformation data={trial.groups_information} admin_mode={admin_mode} />
          </div>



          {this.renderButtons()}

          {this.renderPatientInformation()}
          {this.renderRecentAndConcurrentConfig(population)}
          <GeolocationInformation patient={patient} cache={geolocation}/>
          {this.renderLastLocationVerifiedAt()}
        </div>

        {this.renderPopulationsInfo(population_data)}
        {this.renderNewCollectionModal()}
      </div>
    )
  }
}

const formatDate = (date) => moment(date).format("LLL")



function findCollections({trial,  collections}) {
  if (!collections || collections.length === 0) return [];
  let in_collections = [];

  for (let collection of collections) {
    for (let collection_trial of collection.trials) {
      if (collection_trial.trial_id === trial.id) {
        in_collections.push(collection);
      }
    }
  }
  return in_collections;
}




class CollectionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {collection: {name: ''}, errors: []};
  }

  componentDidMount() {
    this.el = $(this.refs.modal_container);
    this.el.modal({show: true});
    this.el.on('hidden.bs.modal', e => {
      this.cancel(e);
    });
  }

  submit(e) {
    e.preventDefault();
    let {collection} = this.state;
    let {patient, onSubmit} = this.props;
    let url = "/admin/patients/" + patient.id + "/collections"
    request('POST', url, {collection}).then(({success, collection}) => {
      if (success) {
        this.cancel();
        onSubmit(collection);
      }
    });
  }

  onChange(collection) {
    this.setState({collection});
  }

  cancel(e) {
    this.el.modal('hide');
    let {onClose} = this.props;
    onClose();
  }

  formFields() {
    return [
      {name: 'name', required: true}
    ]
  }

  render() {
    let {collection, errors} = this.state;

    return (
      <div className="modal fade" tabIndex="-1" role="dialog" ref="modal_container">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" onClick={e => this.cancel(e)} aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 className="modal-title"><b>New Collection</b></h4>
            </div>

            <div className="modal-body">
              <Form model_name="Collection" prefix="collection" fields={this.formFields()} model={collection} errors={errors} onChange={r => this.onChange(r)} onSubmit={e => this.submit(e)} onCancel={e => this.cancel(e)} />
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-default" onClick={e => this.cancel(e)}>Close</button>
              <button type="submit" className="btn btn-primary" onClick={e => this.submit(e)}>Submit</button>
            </div>

          </div>
        </div>
      </div>

    );
  }
}


function linkToPopulation(population) {
  return `/admin/trials/${population.trial_id}/populations/${population.id}`;
}
